import { createSlice } from '@reduxjs/toolkit';
import { decryptText } from '../../utils/utils';

// Function to retrieve and decrypt user data from localStorage
const storedUser = localStorage.getItem('user');
const auth = storedUser ? JSON.parse(decryptText(storedUser) || '{}') : {};

// Define the initial state with categorized user details
const initialState = {
    user: auth.user || {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        mobile_no: null,
        pan: null,
        aadhaar: null,
        is_mobile_no_verified: null,
        is_email_verified: null,
        terms_conditions: null,
        created_at: null,
        updated_at: null,
    },
    token: auth.token || null,
    expires_at: auth.expires_at || null,
    entityProfileId: auth.entityProfileId || null, // Correctly initialize from auth data
};

const authUserSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        // Set the authenticated user details
        setAuthUser: (state, action) => {
            const { user, token, expires_at, entityProfileId } = action.payload;
            return {
                ...state,
                user: {
                    ...state.user,
                    ...user, // Merge the new user data into the existing user state
                },
                token,
                expires_at,
                entityProfileId, // Store entityProfileId separately
            };
        },
        // Delete the authenticated user details
        deleteAuthUser: () => {
            return { user: initialState.user, token: null, expires_at: null, entityProfileId: null };
        },
    },
});

// Export actions for use in components
export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

// Export the reducer for the store
export default authUserSlice.reducer;
